/**
 * 发现模块路由
 */
import { PAGE_LEVEL } from '@/constants';
import { isElectron } from '@/utils/electron';

export default {
  meta: {
    localeModules: ['market', 'aiChat', 'cloudDocument', 'daily', 'eventSignal', 'report', 'roadshow', 'summary']
  },
  path: '/market',
  redirect: '/market/list',
  children: [
    {
      path: 'list',
      name: 'marketIndex',
      component: () => import(/* webpackChunkName: 'market-research' */ '@/pages/find/list.vue'),
      meta: {
        componentName: 'MarketIndex',
        pageLevel: PAGE_LEVEL.FIRST,
        name: 'routers.find_discover',
        keepAlive: true
      }
    },
    {
      path: 'home',
      name: 'marketHome',
      component: () => import(/* webpackChunkName: 'market-home' */ '@/pages/find/home/index.vue'),
      meta: {
        componentName: 'MarketHome',
        pageLevel: PAGE_LEVEL.FIRST,
        name: 'routers.find_discover',
        // 后端菜单未单独下发该路径，复用「发现」菜单权限
        parent: '/market/list',
        localeModules: ['market', 'daily', 'eventSignal', 'roadshow'],
        keepAlive: true
      }
    },
    {
      path: 'detail',
      name: 'marketDetail',
      component: () => import(/* webpackChunkName: 'market-research-detail' */ '@/pages/find/detail'),
      meta: {
        parent: '/market/list',
        otherParent: ['/market/self-selected'],
        pageLevel: PAGE_LEVEL.SECOND,
        name: 'routers.find_detail'
      }
    },
    {
      path: 'stock',
      name: 'stockRedirect',
      component: () => import(/* webpackChunkName: 'market-research-stock' */ '@/pages/find/stockRedirect'),
      meta: {
        parent: '/market/self-selected',
        pageLevel: PAGE_LEVEL.SECOND,
        name: 'routers.find_stock_detail'
      }
    },
    {
      path: 'self-selected',
      name: 'stockDetail',
      component: () => import(/* webpackChunkName: 'market-research-stock-detail' */ '@/pages/find/stockDetail.vue'),
      meta: {
        // 正常模式下不需要缓存
        componentName: isElectron ? 'StockDetailIndex' : null,
        name: 'routers.find_self_selected',
        parent: '/market/list',
        pageLevel: PAGE_LEVEL.FIRST,
        keepAlive: true,
        breadcrumb: [
          {
            path: '/market/list',
            title: 'routers_find_discover'
          },
          {
            path: '/market/self-selected',
            name: 'stockDetail',
            title: 'routers_find_stock_detail'
          }
        ]
      }
    },
    {
      path: '/self-selected/calendar',
      name: 'selfSelectedCalendar',
      component: () => import(/* webpackChunkName: 'market-research-calendar' */ '@/pages/find/calendarAll'),
      meta: {
        name: 'routers.find_performance_calendar',
        componentName: 'performanceCalendarModuleIndex',
        parent: '/market/self-selected',
        pageLevel: PAGE_LEVEL.SECOND,
        hideBreadcrumb: isElectron,
        keepAlive: true,
        electronSingle: true
      }
    },
    {
      path: 'promote-detail',
      name: 'promoteDetail',
      component: () => import(/* webpackChunkName: 'promote-detail' */ '@/pages/find/promoteDetail.vue'),
      meta: {
        name: 'routers.find_detail',
        parent: '/market/list',
        pageLevel: PAGE_LEVEL.FIRST
      }
    },
    {
      path: 'daily-detail',
      name: 'dailyDetail',
      component: () => import(/* webpackChunkName: 'daily-detail' */ '@/pages/daily/detail/index.vue'),
      meta: {
        parent: '/market/list',
        pageLevel: PAGE_LEVEL.SECOND,
        name: 'routers.find_daily_detail',
        hideBreadcrumb: true,
        electronSingle: true,
        keepAlive: true
      }
    }
  ]
};
